import decode from 'jwt-decode';
const checkAdminAuth = () => {
  const token = localStorage.getItem('token_access');
  if (!token) return false;

  try {
    const { exp } = decode(token);

    if (exp < new Date().getTime() / 1000) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export default checkAdminAuth;
